const WHOLE_NUMBER_EPSILON = 1e-9

export function fmonetary(value, {decimals = undefined} = {}) {
	const amount = Number(value)
	const roundedAmount = Math.round(amount)
	// Treat floating-point artifacts like 3.0000000000000004 as whole amounts so they still render as `€3,-`.
	const isWholeNumber = Number.isFinite(amount) && Math.abs(amount - roundedAmount) < WHOLE_NUMBER_EPSILON
	// Without explicit decimals, preserve the adaptive format: whole amounts use `,-`; other amounts use two decimals.
	const useDefaultFormatting = decimals === undefined
	const showWholeNumberSuffix = isWholeNumber && useDefaultFormatting
	const fractionDigits = decimals ?? (showWholeNumberSuffix ? 0 : 2)

	// Avoid currencyDisplay: 'narrowSymbol'; Safari 13/14 can throw on that option.
	const localizedCurrency = new Intl.NumberFormat('nl-NL', {
		style: 'currency',
		currency: 'EUR',
		minimumFractionDigits: fractionDigits,
		maximumFractionDigits: fractionDigits,
	}).format(amount)

	// remove any non-breaking spaces (\u00A0) or regular spaces
	// Intl.NumberFormat returns '€ 100', we want '€100'
	const currencyWithoutSpaces = localizedCurrency.replace(/\s|\u00A0/g, '')

	return showWholeNumberSuffix ? `${currencyWithoutSpaces},-` : currencyWithoutSpaces
}
